import React from 'react';
import classNames from 'classnames';
import { PrimaryButton } from 'components/buttons';

export default function WizardStepLayout({
  title,
  description,
  children,
  primaryAction,
  actions,
  className = ''
}) {
  return (
    <div className={classNames("space-y-8 max-w-2xl mx-auto", className)}>
      <div className="text-center">
        <h2 className="text-lg font-medium text-white">{title}</h2>
        <p className="mt-1 text-sm text-gray-400">{description}</p>
      </div>

      <div className="w-full">
        {children}
      </div>

      {(primaryAction || actions) && (
        <div className="flex justify-center pt-4">
          <div className="w-full sm:w-64">
            {primaryAction ? (
              <PrimaryButton
                type={primaryAction.type || 'button'}
                onClick={primaryAction.onClick}
                disabled={primaryAction.disabled}
                loading={primaryAction.loading}
                saving={primaryAction.saving}
                className="w-full"
              >
                {primaryAction.label}
              </PrimaryButton>
            ) : actions}
          </div>
        </div>
      )}
    </div>
  );
}
